module.exports = __webpack_public_path__ + "static/media/eco-ecology-flower-svgrepo-com.5db4a5c2.svg";